import React, { FunctionComponent, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Header from '../../components/Header';
import PaymentScreen from '../../components/Payment';
import { sendEvent2 } from '../../utils/tracking';

const Payment: FunctionComponent<any> = ({ history }) => {
  const fromFastag = history?.location?.state?.fromFastag;
  useEffect(() => {
    if (fromFastag) {
      sendEvent2(
        'screen_view',
        {
          event_action: 'view',
          screen_name: 'wallet_recharge_screen',
          target_product: 'fastag',
          event_platform: 'web',
        },
        true,
      );
    }
  }, [fromFastag]);
  return (
    <div>
      <Header title="Add Money to Wallet" history={useHistory()} />
      <div className="flex justify-content-c">
        <PaymentScreen fromFastag={fromFastag} />
      </div>
    </div>
  );
};

export default Payment;
